// src/hooks/useMaintenancePolling.ts
import { maintenanceModeRequest } from 'api/requests/maintenance-request';
import { useEffect, useState } from 'react';
import { useAppSelector } from 'store';
/* eslint camelcase: "off" */
import jwt_decode from 'jwt-decode';

export function useMaintenancePolling() {
  const [isMaintenance, setIsMaintenance] = useState<boolean>(false);
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const intervalId = setInterval(async () => {
      try {
        let email = '';
        if (token) {
          const decodedToken: any = jwt_decode(token);
          email = decodedToken.Email;
        }

        const data = await maintenanceModeRequest(email);
        console.log('maintenance-mode:', data);

        if (email.length === 0) {
          setIsMaintenance(data.status === 'INACTIVE');
        } else {
          setIsMaintenance(data.status === 'INACTIVE' && !data.isExceptionUser);
        }
      } catch (err) {
        console.error('Maintenance check failed:', err);
      }
    }, 3000);

    return () => clearInterval(intervalId);
  }, [token]);

  return { isMaintenance };
}
